import { ReportDashboardComponentKind, VisualizationType } from '@core/reports-types';

import {
  getComponentVisualizationType,
  GetComponentVisualizationTypeInput,
  KiwiImplicitlyGroupedMetrics,
} from './visualization-type';

export const hasPrimarySort = (component: GetComponentVisualizationTypeInput): boolean =>
  getComponentVisualizationType(component) === VisualizationType.PivotTable ||
  component.kind === ReportDashboardComponentKind.Breakdown ||
  component.kind === ReportDashboardComponentKind.SingleMetric ||
  component.kind === ReportDashboardComponentKind.TimeBased;

export const isColumnSortPrimary = (
  component: GetComponentVisualizationTypeInput & { metric?: string },
  columnId: string,
): boolean => {
  if (!hasPrimarySort(component)) {
    return false;
  }

  if (
    columnId === component.primaryGroup &&
    component.kind !== ReportDashboardComponentKind.Trend
  ) {
    // TODO CU-86c4x5z1z
    if (KiwiImplicitlyGroupedMetrics.includes(component.metric)) {
      return false;
    }
    return true;
  }

  if (component.kind === ReportDashboardComponentKind.Trend && columnId === 'month') return true;

  if (
    component.kind === ReportDashboardComponentKind.SingleMetric ||
    component.kind === ReportDashboardComponentKind.TimeBased
  )
    return true;

  if (columnId === 'count') return true;

  return false;
};
